/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementCTCustomErrorResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetPouchDespatchResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * This Api is to validate the prepared pouch in the branch and will be used for Pouch Despatch process
 * @summary Validate Prepared Pouch
 */
export const getDespatchValidate = (pouchID: string, signal?: AbortSignal) => {
  return customInstance<GetPouchDespatchResponseResponse>({
    url: `/bm-pouch-management/v1/despatch/validate/${pouchID}`,
    method: 'get',
    signal,
  });
};

export const getGetDespatchValidateQueryKey = (pouchID: string) => {
  return [`/bm-pouch-management/v1/despatch/validate/${pouchID}`] as const;
};

export const getGetDespatchValidateQueryOptions = <
  TData = Awaited<ReturnType<typeof getDespatchValidate>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementCTCustomErrorResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  pouchID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDespatchValidate>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDespatchValidateQueryKey(pouchID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDespatchValidate>>> = ({ signal }) =>
    getDespatchValidate(pouchID, signal);

  return { queryKey, queryFn, enabled: !!pouchID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDespatchValidate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDespatchValidateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDespatchValidate>>
>;
export type GetDespatchValidateQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementCTCustomErrorResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Validate Prepared Pouch
 */
export const useGetDespatchValidate = <
  TData = Awaited<ReturnType<typeof getDespatchValidate>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementCTCustomErrorResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  pouchID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDespatchValidate>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDespatchValidateQueryOptions(pouchID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
